<app-kyc-accordion accordionTitle="Means Of Id" accordionKey="meansOfId">
  <app-tabs [tabs]="profileTabs" [initialSelectedTab]="0"> </app-tabs>

  <ng-template #profileTemplate let-profileIndex="profileIndex">
    <form class="" [formGroup]="profileFormStates[profileIndex].form">
      <div
        class="form-row flex flex-col gap-5 md:grid md:grid-cols-3 md:gap-x-5"
      >
        <!-- ID Type -->
        <div>
          <app-input-label labelFor="idType" labelClass="label--bottom-margin"
            >ID Type</app-input-label
          >
          <select name="idType" required base-select formControlName="type">
            <option value="" disabled selected>Select ID type</option>
            <option
              *ngFor="let idType of meansOfIdTypes"
              [value]="idType.value"
            >
              {{ idType.label }}
            </option>
          </select>
        </div>

        <!-- ID Number -->
        <div>
          <app-input-label
            labelFor="id_number"
            labelClass="label--bottom-margin"
            [isRequired]="true"
            >ID Number</app-input-label
          >

          <app-input
            placeholder="Enter ID Number"
            [inputClass]="'input--padding'"
            formControlName="number"
          ></app-input>
        </div>

        <!-- Issue Date -->
        <div>
          <app-input-label
            labelClass="label--bottom-margin"
            [isRequired]="requiresExpiry"
            >Issue Date</app-input-label
          >
          <input
            type="date"
            input-date
            class="input--padding"
            formControlName="issue_date"
          />
        </div>

        <!-- Expiry Date -->
        <div>
          <app-input-label
            labelClass="label--bottom-margin"
            [isRequired]="requiresExpiry"
            >Expiry Date</app-input-label
          >
          <input
            type="date"
            input-date
            class="input--padding"
            formControlName="expiry_date"
          />
        </div>
      </div>
      <div class="mt-5 flex justify-end">
        <div
          [ngClass]="{
            'cursor-not-allowed': (profileFormStates[profileIndex].isLoading | async)
          }"
        >
          <button
            type="button"
            mango-button
            [loading]="(profileFormStates[profileIndex].isLoading | async)!!"
            [disabled]="(profileFormStates[profileIndex].isLoading | async)!!"
            (click)="submitForm(profileIndex)"
            class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
          >
            <span
              *ngIf="profileFormStates[profileIndex].isLoading | async"
              spin
              [loadingText]="
                (profileFormStates[profileIndex].hasId | async) === true
                  ? 'Updating Means of ID...'
                  : 'Saving Means of ID...'
              "
            ></span>
            @if (!(profileFormStates[profileIndex].isLoading | async)) {
              {{
                (profileFormStates[profileIndex].hasId | async) === true
                  ? 'Update Means of ID'
                  : 'Add Means of ID'
              }}
            }
          </button>
        </div>
      </div>
    </form>

    @if (!jointDataDetails[profileIndex] && profileIndex > 0) {
      <div
        class="mb-3 inline-flex items-center gap-[0.9rem] rounded-xl bg-mango-floralWhite px-[0.6rem] py-[0.9rem]"
      >
        <img
          src="assets/images/svgs/info-circle--yellow.svg"
          alt=""
          class="h-[1.5625rem] w-[1.5625rem] flex-1"
        />
        <p class="text-sm leading-[1.3125rem] text-mango-grey">
          Profile {{ profileIndex + 1 }} has not been added yet.
        </p>
      </div>
    }
  </ng-template>
</app-kyc-accordion>
